module.exports = __webpack_public_path__ + "img/25_newYouth_wzs.242bedfa.png";